import React, {useState} from 'react'
import {Collapse} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import Tr from 'translations/Translations';
import Divider from '../../../../../../../../components/Divider';
import RequiredFields from './RequiredFields';
import OptionalFields from './OptionalFields';
import moment from 'moment';
import CheckboxButton from 'components/CheckboxButton';
import GridBlock from 'components/GridBlock';
import {connect} from 'react-redux'
import Loading from 'components/Loading';
import getObjectValue from 'libs/getObjectValue'
import DemandService from 'services/DemandService';
import ContactFields from './ContactFields';
import HelpTooltip from 'components/HelpTooltip';
import SaveFormikValues from 'components/SaveFormikValues';
import validationSchema from './constants/validationSchema';
import ShowErrorOnFailedSubmit from 'components/ShowErrorOnFailedSubmit';
import {DemandValidation} from 'constants/DemandValidation';
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import HeaderService from "services/HeaderService";
import {useParams, withRouter} from "react-router";
import {isNonpublicProcedure} from "constants/ProcedureType";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import AutoSaveFormValues from "components/AutoSaveFormValues";
import saveFormDraft from "libs/saveFormDraft";

function MainForm(
    {
        data,
        demandAvailableOrganizations,
        demandRealizationTypes,
        demandAvailableFormTypes,
        numberAutomated,
        caseClassificationSymbolRequired,
        stepperState,
        demandValidation,
        demandHeader
    }) {
    const [checkError, setCheckError] = useState(false)
    const section = demandValidation.find(x => x.section === DemandValidation.DEMAND);
    const FORM_ID = 'mp_1_demand'
    const params = useParams();
    const autoSaveFormDraftActive = demandHeader?.applicationClientSettings.autoSaveFormDraft.active;
    useStepperStateCloseValidator(FORM_ID, undefined,
        autoSaveFormDraftActive ? () => DemandService.deleteDraft(params.id) : undefined,
        autoSaveFormDraftActive ? () => saveFormDraft(params.id, DemandService.saveDraft, FORM_ID) : undefined);

    if (!data || !demandAvailableOrganizations || !demandRealizationTypes || !demandAvailableFormTypes || !demandHeader) {
        return <Loading/>
    }


    const handleSubmit = (values) => {
        DemandService.save(values).then(() => {
            if (data.identity !== -1) {
                HeaderService.get(data.identity)
            }
        });
    }

    const getField = (id, defaultValue = '') => getObjectValue(id, data, defaultValue)
    const getTimeField = (id, defaultValue = null) => {
        const v = getField(id, defaultValue);

        if (v) return moment(v);
        return v;
    }

    return (
        <Form
            initialValues={{
                _editable: section ? section.editable : true,
                identity: getField('identity'),
                organization: getField('organization'),
                procedureType: getField('procedureType'),
                authorUser: getField('authorUser'),
                number: getField('number'),
                demandCategoryType: getField('demandCategoryType', null),
                caseClassificationSymbol: getField('caseClassificationSymbol', null),
                name: getField('name'),
                description: getField('description'),
                formType: getField('formType'),
                demandRealizationType: getField('demandRealizationType'),
                pzpExclusion: getField('pzpExclusion'),
                demandOrderType: getField('demandOrderType'),
                demandVariant: getField('demandVariant'),
                primaryTenderVariant: getField('primaryTenderVariant'),
                plannedContractorNumberForAgreement: getField('plannedContractorNumberForAgreement'),
                digitalSign: String(getField('digitalSign')),
                requiredJEDZ: getField('requiredJEDZ'),
                auctionMade: String(getField('auctionMade', false)),
                categoryItemCpv: getField('categoryItemCpv'),
                fundingInstitutionLogo: getField('fundingInstitutionLogo'),

                contactPerson: getField('contactPerson'),
                contactPersonPhone: getField('contactPersonPhone'),
                contactPersonEmail: getField('contactPersonEmail'),
                purchaserName: getField('purchaserName'),
                purchaserPhone: getField('purchaserPhone'),
                purchaserFax: getField('purchaserFax'),
                purchaserEmail: getField('purchaserEmail'),
                purchaserAdditionalInfo: getField('purchaserAdditionalInfo'),

                externalPurchaseRequestNumber: getField('externalPurchaseRequestNumber'),
                euFunded: String(getField('euFunded')),
                singleDealingJustification: getField('singleDealingJustification'),
                demandJustification: getField('demandJustification'),
                planPropositionText: getField('planPropositionText'),
                estimationBase: getField('estimationBase'),
                financialSource: getField('financialSource'),

                termOption: getField('agreementRealizationDate.text') ? "text" : "date",
                termDate: getTimeField('agreementRealizationDate.date'),
                termDescription: getField('agreementRealizationDate.text', ''),

                orderValueDecisionDate: getTimeField('orderValueDecisionDate'),
                fullNameOrderValueDecisionPerson: getField('fullNameOrderValueDecisionPerson'),
                managerEntrustedPerson: getField('managerEntrustedPerson'),

                enableOptional: false,

                passiveOfferForm: getField('passiveOfferForm'),
                euProjectNumber: getField('euProjectNumber'),
                priceType: getField('priceType'),

                ezdrpId: getField('ezdrpId'),
                ezdpuwId: getField('ezdpuwId'),
            }}
            validationSchema={validationSchema(demandRealizationTypes, numberAutomated, caseClassificationSymbolRequired)}
            onSubmit={handleSubmit}
            id={FORM_ID}
            afterSubmitFunc={() => {
                setCheckError(true);
                if (isDemandModification()) {
                    ModificationService.isDemandChanged(data.identity);
                }
            }}
        >
            {(formikProps) => {
                const passiveOfferForm = getObjectValue('passiveOfferForm', formikProps.values, false);
                const procedureType = getObjectValue('procedureType', formikProps.values, "");
                const nonpublicProcedure = isNonpublicProcedure(procedureType);
                const _editable = getObjectValue('_editable', formikProps.values, true);
                return (
                    <GridBlock
                        column
                    >
                        <ShowErrorOnFailedSubmit
                            formikProps={formikProps}
                            checkError={checkError}
                            setCheckError={setCheckError}
                        />
                        <SaveFormikValues
                            formikProps={formikProps}
                            id={FORM_ID}
                            save={FORM_ID === stepperState}
                        />
                        {autoSaveFormDraftActive &&
                        <AutoSaveFormValues
                            formikProps={formikProps}
                            id={getField('identity')}
                            formId={FORM_ID}
                            saveFunc={(formValues) => {
                                DemandService.saveDraft(getField('identity'), formValues)
                            }}
                        />
                        }
                        <RequiredFields
                            formikProps={formikProps}
                            demandAvailableOrganizations={demandAvailableOrganizations}
                            demandRealizationTypes={demandRealizationTypes}
                            demandAvailableFormTypes={demandAvailableFormTypes}
                            demandHeader={demandHeader}
                            numberAutomated={numberAutomated}
                            caseClassificationSymbolRequired={caseClassificationSymbolRequired}
                            hideExecutiveDemandVariant={getField('hideExecutiveDemandVariant', true)}
                        />

                        <Divider>
                            {`${Tr('contact_data')} (${Tr('optional')})`}
                        </Divider>

                        <ContactFields
                            formikProps={formikProps}
                        />

                        {!passiveOfferForm && !nonpublicProcedure &&
                            <Divider>
                                {`${Tr('additional_data')} (${Tr('optional')})`}
                                <HelpTooltip text={Tr('tooltip_additional_data')}/>
                            </Divider>
                        }

                        {!passiveOfferForm && !nonpublicProcedure &&
                            <Collapse in={formikProps.values.enableOptional}>
                                <OptionalFields formikProps={formikProps}/>
                            </Collapse>
                        }

                        {!passiveOfferForm && !nonpublicProcedure &&
                            <CheckboxButton
                                id='enableOptional'
                                label={
                                    formikProps.values.enableOptional ?
                                        Tr('hide_additional_fields') :
                                        _editable ? Tr('fill_additional_fields') : Tr('show_additional_fields')
                                }
                                formikProps={formikProps}
                            />
                        }

                    </GridBlock>
                )
            }}
        </Form>
    )
}

MainForm.propTypes = {
    classes: PropTypes.any,
}

MainForm.defaultProps = {}


export default connect((state) => ({
    data: state.resources.demand,
    demandAvailableOrganizations: state.resources.demandAvailableOrganizations,
    demandRealizationTypes: state.resources.demandRealizationTypes,
    demandAvailableFormTypes: state.resources.demandAvailableFormTypes,
    numberAutomated: state.resources.demandNumberAutomated,
    caseClassificationSymbolRequired: state.resources.caseClassificationSymbolRequired,
    demandHeader: state.resources.demandHeader,
    stepperState: state.stepper.state,
    demandValidation: state.resources.demandValidation,
}), {})(withRouter(MainForm));
